// @flow
import React from 'react';
import classnames from 'classnames';

import ClientConfig from '../../context/clientConfig';
import Logo from '../logo';

const HeaderWithLogo = () => (
  <ClientConfig.Consumer>
    {clientConfig => {
      const {
        headerLogoClassNames, justifyLogo, logoURI, logoLink, logoClassNames, logoImgAlt,
      } = clientConfig;
      return (
        <div
          className={classnames(
            `${headerLogoClassNames || ''} client-header align-items-center`,
            {
              'd-flex justify-content-between': justifyLogo === 'start',
            },
            {
              'd-flex justify-content-center': justifyLogo === 'center',
            },
            {
              'd-flex justify-content-end': justifyLogo === 'end',
            },
          )}
        >
          <Logo
            logoURI={logoURI}
            logoLink={logoLink}
            logoClassNames={logoClassNames}
            logoImgAlt={logoImgAlt}
            justifyLogo={justifyLogo}
          />
        </div>
      );
    }}
  </ClientConfig.Consumer>
);

export default HeaderWithLogo;
